export class PdfViewer {
	#blobParts;

	constructor(blobParts) {
		this.#blobParts = blobParts;
	}

	execute() {
		const file = new Blob(this.#blobParts, { type: 'application/pdf' });
		const fileURL = URL.createObjectURL(file);
		window.open(fileURL, '_blank');
	}
}
